import { render } from "./nHerder.vue?vue&type=template&id=1ad5513e&scoped=true"
import script from "./nHerder.vue?vue&type=script&lang=js"
export * from "./nHerder.vue?vue&type=script&lang=js"

import "./nHerder.vue?vue&type=style&index=0&id=1ad5513e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1ad5513e"

export default script